<template>
  <div>
    <p class="searchExams__card--title">{{ exam.name }}</p>
    <div class="searchExams__card--body">
      <p class="searchExams__card--similarNames" v-if="!hideSynonymy">
        {{ exam.similarNames }}
      </p>
      <div class="searchExams__card--bottomLine">
        <div class="amount">
          <span class="amount__labelPrice">Para particular</span>
          <span class="amount__value">
            {{ formatCurrency(exam.price) }}
          </span>
        </div>
        <div class="searchExams__card--cta">
          <button
            class="searchExams__card--href"
            v-if="!exam.added"
            @click="$emit('addExamClick', $event, exam, idx)"
          >
            Adicionar
            <PlusSvg class="plus-svg" />
          </button>
          <div class="searchExams__card--removeExam" v-else-if="exam.added">
            <CheckCircleSvg class="check-circle-svg" />
            <span class="searchExams__card--examsStatus"> Adicionado </span>
            <TrashSvg
              class="trash-svg"
              @click="$emit('removeExamClick', $event, exam, idx)"
              alt="Remover exame"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'examsListCard',
  props: {
    exam: {
      default: {
        name: '',
        similarNames: '',
        id: 1,
        added: false,
      },
    },
    idx: {
      default: 0,
    },
    hideSynonymy: {
      default: false,
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
  },
};
</script>

<style lang="scss">
.searchExams {
  &__card {
    border: 1px solid rgba(22, 22, 22, 0.24);
    border-radius: 4px;
    margin: 24px auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &--title {
      font-size: var(--font-size-3);
      font-weight: var(--font-weight-bold);
      line-height: 150%;
      text-transform: uppercase;
      text-align: left;
      color: #161616;
    }

    &--similarNames {
      font-size: var(--font-size-2);
      line-height: 150%;
      text-transform: uppercase;
      text-align: left;
      color: #363636;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    &--href {
      font-size: var(--font-size-2);
      line-height: 150%;
      color: var(--color-interaction-accent-1);
      border: 1px solid var(--color-interaction-accent-1);
      padding: 2px 4px;
      cursor: pointer;
      background: none;
      border-radius: 4px;
      font-weight: var(--font-weight-bold);
    }

    &--cta {
      padding-left: 24px;
    }

    &--body {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &--bottomLine {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    &--examsStatus {
      font-weight: 400;
      font-size: 14px;
      line-height: 115%;
      color: #22723a;
      margin-right: 14px;
    }

    &--removeExam {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}

.plus-svg {
  width: auto;
  height: auto;
  vertical-align: middle;
  transform: scale(0.75) translateX(-2px) translateY(-3px);

  path {
    fill: var(--color-interaction-accent-1);
  }
}

.trash-svg {
  width: 18px;
  height: 18px;
}

.check-circle-svg {
  width: 18px;
  height: 18px;

  path {
    fill: #22723a;
  }
}

.amount {
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  align-items: flex-start;

  &__labelPrice {
    font-size: 12px;
    line-height: 16px;
    color: #1c5e30;
  }

  &__value {
    color: rgba(22, 22, 22, 0.64);
    font-size: var(--font-size-3);
    font-weight: var(--font-weight-bold);
    line-height: 24px;
  }
}
</style>
